export default __webpack_public_path__ + "static/media/carat-down.7ef98105.svg";